import { IconX, IconSearch, IconInbox } from '@tabler/icons-react'

// Page Header
export function PageHeader({ title, subtitle, pretitle, actions }) {
  return (
    <div className="page-header d-print-none mb-4">
      <div className="row align-items-center">
        <div className="col-auto">
          {pretitle && <div className="page-pretitle">{pretitle}</div>}
          <h2 className="page-title">{title}</h2>
          {subtitle && <div className="text-secondary mt-1" style={{ fontSize: '0.85rem' }}>{subtitle}</div>}
        </div>
        {actions && <div className="col-auto ms-auto d-print-none d-flex gap-2">{actions}</div>}
      </div>
    </div>
  )
}

// Stat Card
export function StatCard({ label, value, change, icon: Icon, color = 'primary' }) {
  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex align-items-center">
          <div className="subheader">{label}</div>
          {Icon && (
            <div className="ms-auto">
              <span className={`bg-${color}-lt text-${color} avatar avatar-sm rounded`}>
                <Icon size={20} />
              </span>
            </div>
          )}
        </div>
        <div className="h1 mb-0 mt-2">{value}</div>
        {change && <div className="text-secondary mt-1" style={{ fontSize: '0.75rem' }}>{change}</div>}
      </div>
    </div>
  )
}

// Status Badge
export function StatusBadge({ status, color }) {
  const colorMap = { new: 'blue', contacted: 'cyan', qualified: 'purple', proposal_sent: 'yellow',
    negotiation: 'orange', closed_won: 'green', closed_lost: 'red', tentative: 'yellow',
    definite: 'green', cancelled: 'red', draft: 'secondary', sent: 'blue', viewed: 'cyan',
    accepted: 'green', declined: 'red', expired: 'secondary', signed: 'green',
    pending: 'yellow', in_progress: 'cyan', completed: 'green', discovery: 'blue',
    qualification: 'purple', proposal: 'yellow' }
  const c = color || colorMap[status] || 'secondary'
  const label = (status || '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
  return <span className={`badge bg-${c}-lt`}>{label}</span>
}

// Search Input
export function SearchInput({ value, onChange, placeholder = 'Search...' }) {
  return (
    <div className="input-icon" style={{ maxWidth: 260 }}>
      <span className="input-icon-addon"><IconSearch size={16} /></span>
      <input type="text" className="form-control form-control-sm" placeholder={placeholder}
        value={value} onChange={e => onChange(e.target.value)} />
    </div>
  )
}

// Modal
export function Modal({ open, onClose, title, children, wide }) {
  if (!open) return null
  return (
    <div className="modal modal-blur show d-block" tabIndex={-1} style={{ background: 'rgba(0,0,0,0.5)' }}>
      <div className={`modal-dialog ${wide ? 'modal-lg' : ''} modal-dialog-centered`}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>
          <div className="modal-body">{children}</div>
        </div>
      </div>
    </div>
  )
}

// Empty State
export function EmptyState({ icon: Icon, title, message }) {
  return (
    <div className="empty">
      <div className="empty-icon">{Icon ? <Icon size={48} className="text-secondary" /> : <IconInbox size={48} className="text-secondary" />}</div>
      <p className="empty-title">{title || 'No results found'}</p>
      {message && <p className="empty-subtitle text-secondary">{message}</p>}
    </div>
  )
}
